// extracted by mini-css-extract-plugin
export default {"form-field-label":"FieldLabel_form-field-label__PjmgE","is-invalid":"FieldLabel_is-invalid__i9M85"};